import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import './privacypolicy.css'
import { useEffect } from "react";

export default function TermsOfUse({}){

    const navigate = useNavigate();

    useEffect(() => {
        const verified = localStorage.getItem("verificado");
        const auth = localStorage.getItem("auth");
        if(auth === "true"){
            if(verified === "false"){
                navigate('/EmailVerify')
            }
        }
    }, []);

    return(
        <div>
            <Header></Header>

            <div className="privacypolicy-container">
                <div className="privacypolicy-content">

                    <h1>Termos de Uso - Me localizaÊ</h1>

                    <p><strong>Última atualização:</strong> 18/12/2025</p>

                    <p>
                    Estes Termos de Uso estabelecem as regras e condições para utilização da plataforma 
                    <strong> Me localizaÊ</strong>.
                    </p>

                    <p>
                    Ao acessar ou utilizar a plataforma, realizar cadastro ou contratar qualquer serviço oferecido pela 
                    Me localizaÊ, o usuário declara que leu, compreendeu e concorda com estes Termos.
                    </p>

                    <p>
                    Caso não concorde com qualquer condição aqui descrita, o usuário não deverá utilizar a plataforma.
                    </p>


                    <h2>1. Sobre a plataforma</h2>

                    <p>
                    A Me localizaÊ é uma plataforma digital que oferece informações, análises e relatórios sobre bairros e regiões,
                    com o objetivo de auxiliar usuários na tomada de decisão sobre onde morar, investir ou conhecer melhor determinadas localidades.
                    </p>

                    <p>As informações disponibilizadas podem incluir:</p>

                    <p>Segurança pública</p>
                    <p>Mobilidade urbana</p>
                    <p>Infraestrutura urbana</p>
                    <p>Condições ambientais</p>
                    <p>Indicadores urbanos e estatísticos</p>


                    <h2>2. Cadastro de usuários</h2>

                    <p>
                    Para utilizar determinadas funcionalidades da plataforma poderá ser necessário realizar um cadastro.
                    </p>

                    <p>O usuário se compromete a:</p>

                    <p>Fornecer informações verdadeiras, completas e atualizadas</p>
                    <p>Manter seus dados de acesso protegidos</p>
                    <p>Não compartilhar sua conta com terceiros</p>
                    <p>Informar imediatamente caso identifique uso não autorizado de sua conta</p>

                    <p>
                    O usuário é responsável por todas as atividades realizadas por meio de sua conta.
                    </p>

                    <p>
                    A Me localizaÊ poderá suspender ou cancelar contas que violem estes Termos.
                    </p>


                    <h2>3. Uso permitido da plataforma</h2>

                    <p>
                    O usuário concorda em utilizar a plataforma apenas para fins legítimos e de acordo com a legislação vigente.
                    </p>

                    <p>Não é permitido:</p>

                    <p>Utilizar a plataforma para atividades ilegais</p>
                    <p>Tentar acessar áreas restritas do sistema sem autorização</p>
                    <p>Realizar engenharia reversa ou tentativa de exploração da plataforma</p>
                    <p>Copiar, distribuir ou reproduzir conteúdos da plataforma sem autorização</p>
                    <p>Utilizar robôs, crawlers ou scripts automatizados para coleta de dados sem autorização</p>


                    <h2>4. Propriedade intelectual</h2>

                    <p>
                    Todos os conteúdos da plataforma, incluindo textos, relatórios, gráficos, mapas, códigos,
                    identidade visual e estrutura da plataforma são protegidos por direitos de propriedade intelectual.
                    </p>

                    <p>
                    Esses conteúdos pertencem à Me localizaÊ ou são utilizados mediante licenciamento.
                    </p>

                    <p>
                    Não é permitido reproduzir, distribuir, modificar ou comercializar qualquer conteúdo da plataforma
                    sem autorização prévia e expressa.
                    </p>


                    <h2>5. Precisão das informações</h2>

                    <p>
                    A Me localizaÊ utiliza diversas fontes públicas, bases de dados e metodologias próprias
                    para gerar seus relatórios e análises.
                    </p>

                    <p>
                    Apesar do esforço para garantir a qualidade das informações, os dados podem sofrer atualizações,
                    variações ou imprecisões provenientes das fontes utilizadas.
                    </p>

                    <p>
                    As informações disponibilizadas possuem caráter informativo e de apoio à decisão,
                    não constituindo garantia absoluta sobre qualquer condição futura de determinada região.
                    </p>


                    <h2>6. Relatórios e serviços pagos</h2>

                    <p>
                    Alguns conteúdos ou funcionalidades da plataforma poderão ser disponibilizados mediante pagamento.
                    </p>

                    <p>
                    Ao adquirir relatórios ou serviços, o usuário recebe uma licença de uso pessoal do conteúdo adquirido.
                    </p>

                    <p>
                    O conteúdo adquirido não poderá ser redistribuído, reproduzido ou revendido sem autorização expressa da Me localizaÊ.
                    </p>


                    <h2>7. Disponibilidade da plataforma</h2>

                    <p>
                    A Me localizaÊ envidará esforços para manter a plataforma disponível e funcionando corretamente.
                    </p>

                    <p>
                    Entretanto, não garantimos que o serviço estará disponível de forma ininterrupta ou livre de falhas,
                    podendo ocorrer interrupções temporárias para manutenção, atualização ou ajustes técnicos.
                    </p>


                    <h2>8. Limitação de responsabilidade</h2>

                    <p>
                    Na máxima extensão permitida pela legislação aplicável, a Me localizaÊ não se responsabiliza por:
                    </p>

                    <p>Decisões tomadas com base nas informações da plataforma</p>
                    <p>Danos indiretos decorrentes do uso da plataforma</p>
                    <p>Indisponibilidade temporária do serviço</p>
                    <p>Falhas causadas por fatores externos ou serviços de terceiros</p>


                    <h2>9. Privacidade e proteção de dados</h2>

                    <p>
                    O tratamento de dados pessoais é realizado de acordo com a Política de Privacidade da Me localizaÊ,
                    que descreve como os dados são coletados, utilizados e protegidos.
                    </p>

                    <p>
                    Recomendamos a leitura da Política de Privacidade disponível na plataforma.
                    </p>


                    <h2>10. Alterações nos Termos de Uso</h2>

                    <p>
                    Estes Termos de Uso poderão ser atualizados periodicamente.
                    </p>

                    <p>
                    O uso contínuo da plataforma após eventuais alterações será considerado como concordância com as novas condições.
                    </p>


                    <h2>11. Legislação aplicável</h2>

                    <p>
                    Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil.
                    </p>


                    <h2>12. Contato</h2>

                    <p>
                    Em caso de dúvidas sobre estes Termos de Uso, entre em contato:
                    </p>

                    <p><strong>E-mail:</strong> contato@melocalizae.com.br</p>

                </div>
            </div>
        </div>
    )
}